import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import { FC } from 'react';
import Image from 'global/Image';
import { warningContent } from 'global/StreamWidget/constants';
import { Modal } from './styled';

interface ModalWarningProps {
  onSubmit: () => void;
  onCancel: () => void;
  visible: boolean;
}

export const ModalWarning: FC<ModalWarningProps> = ({
  onSubmit,
  visible,
  onCancel,
}) => (
  <Modal onCancel={onCancel} visible={visible} centered width={480}>
    <Text align="center" style={{ marginBottom: '20px' }}>
      <Image
        src="/images/SpamWarning.svg"
        width={180}
        height={135}
        alt="Post Warning"
      />
    </Text>
    <Text
      align="center"
      size="18px"
      weight={700}
      color={color.highempahis}
      style={{ marginBottom: '12px' }}
    >
      Content Warning
    </Text>
    <Text
      align="center"
      size="14px"
      color="#858585"
      style={{ marginBottom: '32px' }}
    >
      {warningContent}
    </Text>
    <Button block height="44px" radius="4px" onClick={onSubmit} danger ghost>
      <Text weight="700" color={color.sunsetOrange}>
        Report
      </Text>
    </Button>
  </Modal>
);

export default ModalWarning;
